export const ARTICLE_SET_ACTIVE = 'ARTICLE_SET_ACTIVE';
export const ARTICLES_RECEIVE = 'ARTICLES_RECEIVE';
export const ARTICLES_REQUEST = 'ARTICLES_REQUEST';
export const ARTICLES_REQUEST_FAILURE = 'ARTICLES_REQUEST_FAILURE';

export const SITE_SET_ACTIVE = 'SITE_SET_ACTIVE';

export const SETTINGS_SET_VALUE = 'SETTINGS_SET_VALUE';


/** WEBPACK FOOTER **
 ** ./src/state/action-types.js
 **/